import { DataTablesRecipient } from "@components/general/DataTablesRecipient/DataTablesRecipient";
import React from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import columns from "../Datatables/columns";
import { useContext } from "react";
import UserContext from "@context/User/UserContext";
import { useState } from "react";
import { validarDatosPago } from "@helpers/httpRequests/httpRequestsSAI/httpRequestsSAI";
import { useEffect } from "react";
import getPrecioFormateado from "@helpers/formateoPrecios/getPreciosFormateado";
import getDateFromAPIPagos from "@helpers/dates/getDateFromAPIPagos/getDateFromAPIPagos";
import { createCheckoutSession, getPriceAbono } from "@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos";
import stripe from "@helpers/stripe/stripe";
import Swal from "sweetalert2";
import { Notificacion } from "@components/general/Alertas/Alertas";
import { Animated } from "react-animated-css";
import Loader from "@helpers/loader/loader";
import dashboardRoutesPaths from "@helpers/dashboardRoutesPaths/dashboardRoutesPaths";
import typesTiposUsuario from "@helpers/types/typesTiposUsuario";

const HistorialPagos = () => {
	const { contextValue, setContextValue } = useContext(UserContext);

	const { usuarioLogeado } = contextValue;

	let { folioContrato, rol, licenciaRenovacion, folioRenovacion } = usuarioLogeado;

	if (rol === typesTiposUsuario.administrador) {
		folioContrato = "754";
	}

	const [datosPago, setDatosPago] = useState([]);

	const [montoPagado, setMontoPagado] = useState(0);

	const [pagos, setPagos] = useState([]);

	const [costoTotalPagado, setCostoTotalPagado] = useState(true);

	const [showLoader, setShowLoader] = useState(true);

	const handlePagar = async () => {
		try {
			const { idPrecio } = await getPriceAbono(true);

			const sessionData = {
				success_url: `${window.location.origin}${dashboardRoutesPaths.pagos.abonoRealizadoLoggedIn}`,
				cancel_url: `${window.location.origin}${dashboardRoutesPaths.dashboard}`,
				line_items: [{ price: idPrecio, quantity: 1 }],
				mode: "payment",
				currency: "mxn",
				metadata: {
					folioContrato,
					metodoPago: "contado",
				},
			};

			const checkoutSession = await createCheckoutSession(sessionData);

			const { isConfirmed } = await Swal.fire({
				title: "Saliendo de Click+",
				text: "Estás a punto de ser redirigido al sitio de pago",
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonText: "Entendido",
				cancelButtonText: "Cancelar",
				confirmButtonColor: "#0d6efd",
				allowOutsideClick: false,
			});

			if (!isConfirmed) {
				return Notificacion("info", "El pago fue cancelado");
			}

			setContextValue({
				...contextValue,
				stripeSession: checkoutSession,
			});

			await (await stripe).redirectToCheckout({ sessionId: checkoutSession.id });
		} catch (error) {
			console.log("Error al generar el pago: ", error);
		}
	};

	useEffect(() => {
		const validarPago = async () => {
			try {
				let folioContratoAux = licenciaRenovacion ? `${folioContrato}-${folioRenovacion}` : folioContrato;

				const { data } = await validarDatosPago(folioContratoAux);

				const { pagosContrato, pagado, costoTotal } = data;

				setDatosPago(data);

				setPagos(pagosContrato);

				setMontoPagado(pagado);

				setCostoTotalPagado(pagado === costoTotal);

				setShowLoader(false);
			} catch (error) {
				console.log(error);
			}
		};

		validarPago();
	}, []);

	return (
		<>
			{showLoader ? (
				<Loader />
			) : (
				<Animated animationIn="fadeIn" animationInDuration={2000} animationOut="fadeOut" isVisible={true}>
					<Container fluid className="mt-4">
						<Row className="mb-4">
							<Col>
								<Card style={{ background: "#f8f9fa" }} className="shadow">
									<Container fluid>
										<Row>
											<Col>
												<h3 className="mb-3">Tu suscripción</h3>

												<p>
													<b>Folio de contrato:</b> {folioContrato}
												</p>

												<p>
													<b>Total pagado a la fecha:</b> ${getPrecioFormateado(montoPagado)}
												</p>

												{costoTotalPagado ? (
													<p>
														<b>Tu Licencia Click+ ha sido pagada en su totalidad</b>
													</p>
												) : (
													<p>
														<b>Proxima fecha de pago:</b> {getDateFromAPIPagos(datosPago.fechaProximoPago)}
														<Button variant="success" className="ms-3" onClick={handlePagar}>
															Pagar ahora
														</Button>
													</p>
												)}
											</Col>
										</Row>
									</Container>
								</Card>
							</Col>
						</Row>

						<Row>
							<Col>
								<DataTablesRecipient columns={columns} data={pagos} />
							</Col>
						</Row>
					</Container>
				</Animated>
			)}
		</>
	);
};

export default HistorialPagos;
